var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"auto-scroll",staticClass:"auto-scroll",style:({ height: _vm.height }),on:{"touchstart":_vm.onTouchStart,"touchend":function($event){_vm.isTouchEnd = true}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }